import { forwardRef, useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";

// Drop-in replacement for an <Input type="password" /> with a show/hide toggle.
// Forwards ref + spreads any extra props onto the inner Input. Pass `data-testid`
// to identify the field; the eye-toggle gets `<testid>-toggle` automatically.
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", ...props },
  ref,
) {
  const [shown, setShown] = useState(false);
  const baseTid = props["data-testid"];
  return (
    <div className="relative">
      <Input
        {...props}
        ref={ref}
        type={shown ? "text" : "password"}
        className={`pr-10 ${className}`}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShown((v) => !v)}
        aria-label={shown ? "Hide password" : "Show password"}
        title={shown ? "Hide password" : "Show password"}
        className="absolute inset-y-0 right-0 w-10 flex items-center justify-center text-slate-400 hover:text-slate-950"
        data-testid={baseTid ? `${baseTid}-toggle` : undefined}
      >
        {shown ? <EyeSlash size={15} weight="bold" /> : <Eye size={15} weight="bold" />}
      </button>
    </div>
  );
});

export default PasswordInput;
